import classes from "./MediaList.module.less";
import type { MediaItem } from "~/MediaLibrary/types/mediaLibraryTypes";
import MediaLibraryItem from "../MediaLibraryItem/MediaLibraryItem";
import Spinner from "~/common/components/Spinner/Spinner";
import NoMediaFound from "../NoMediaFound/NoMediaFound";

export default function MediaList(props: {
  mediaItems: MediaItem[];
  loading: boolean;
  handleCardClick: (media: MediaItem) => void;
  handleFavouriteClick: (id: string, updatedFav: boolean) => void;
}) {
  const { mediaItems, loading, handleCardClick, handleFavouriteClick } = props;

  if (!loading && mediaItems.length === 0) {
    return <NoMediaFound />;
  }

  return (
    <div className={classes.listContainer}>
      <div className={classes.mediaList}>
        {(!loading || mediaItems.length > 0) &&
          mediaItems.map((item) => <MediaLibraryItem
              media={item}
              key={item.id}
              handleCardClick={handleCardClick}
              handleFavouriteClick={handleFavouriteClick}
            />
          )}
      </div>
      {loading && <div className={classes.spinnerContainer}><Spinner className={classes.spinner} /></div>}
    </div>
  );
}
